import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ScaricaDocumentiConservatiComponent } from './scarica-documenti-conservati';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription.scarica-documenti-conservati', {
            url: '/scarica-documenti-conservati',
            //                        ncyBreadcrumb: {
            //                            label: 'Scarica Documenti Conservati',
            //                            parent: 'unsubscription.unsubscription-index'
            //                        },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Scarica Documenti Conservati'
            },
            'views': {
                'multiContentUnsubscription': {
                    template: '<scarica-documenti-conservati flex="100"></scarica-documenti-conservati>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ScaricaDocumentiConservatiModule: string = ng
    .module('scarica-documenti-conservati', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('scaricaDocumentiConservati', ScaricaDocumentiConservatiComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/scarica-documenti-conservati/scarica-documenti-conservati.module.ts